import { getPreBuiltSections } from '../pluginComponentApi';
export default (editor, opts = {}) => {
  const cmd = editor.Commands;
  const {
    modalTitle,
    codeViewOptions,
    commandPreBuiltSectionCode,
    refs,
    commands,
    labels,
    placeholderContent,
    selectArrow,
    titles,
    categories,
    projectId,
    version,
  } = opts;
  const { keyMarketPlaceCustomCode } = refs;
  const appendToContent = (target, content) => {
    if (content instanceof HTMLElement) {
      target.appendChild(content);
    } else if (content) {
      target.insertAdjacentHTML('beforeend', content);
    }
  };

  let preBuiltSectionSelectList = [];

  cmd.add(commands.pre_built_section_custom_code, {
    keyMarketPlaceCustomCode,

    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const target = this.target;

      if (target && target.get('editable')) {
        this.showPreBuiltSectionCode(target);
      }
    },

    stop(editor) {
      editor.Modal.close();
    },

    async showPreBuiltSectionCode(target) {
      const { editor, options } = this;
      const title = options.title || modalTitle;
      const content = this.getContent();
      const code = target.get(keyMarketPlaceCustomCode) || '';
      editor.Modal.open({ title, content })
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));
      this.getCodeViewer().setContent(code);
    },
    getPreContent() {},
    getPostContent() {},
    getBreakPoint() {
      const contentBreak = document.createElement('br');
      return contentBreak;
    },

    getContent() {
      const { editor } = this;
      const content = document.createElement('div');
      const galleryDiv = document.createElement('div');
      const categoryLabel = document.createElement('label');

      const selectCategoryOptionDiv = document.createElement('div');
      const selectCategoryOptionArrow = document.createElement('div');
      const selectCategoryOption = document.createElement('select');

      const codeViewer = this.getCodeViewer();
      const pfx = editor.getConfig('stylePrefix');

      content.className = `${pfx}pre-built-section`;
      categoryLabel.className = `${pfx}pre-built-section-category-label col-5 no-break`;
      galleryDiv.className = `${pfx}pre-built-section-gallery-div row`;

      selectCategoryOption.className = `${pfx}pre-built-section-category`;
      selectCategoryOptionDiv.className = `${pfx}pre-built-section-category ${pfx}field ${pfx}select col-4 two-break`;
      selectCategoryOptionArrow.className = `${pfx}pre-built-section-category ${pfx}sel-arrow`;

      selectCategoryOption.id = `${pfx}pre-built-section-category-select`;
      selectCategoryOptionDiv.id = `${pfx}pre-built-section-category-select-div`;
      categoryLabel.id = `${pfx}pre-built-section-category-label`;
      galleryDiv.id = `${pfx}pre-built-section-gallery-div`;

      appendToContent(content, this.getPreContent());
      appendToContent(categoryLabel, this.getPreContent());
      appendToContent(selectCategoryOptionDiv, this.getPreContent());
      appendToContent(selectCategoryOption, this.getPreContent());
      appendToContent(galleryDiv, this.getPreContent());

      //Create and append the category options
      let optionCategory = document.createElement('option');
      optionCategory.value = 'ALL';
      optionCategory.text = '-- Select Category --';
      selectCategoryOption.appendChild(optionCategory);

      //Create and append the section category options
      categories.forEach((elementCategory) => {
        let optionCategory = document.createElement('option');
        optionCategory.value = elementCategory.value;
        optionCategory.text = elementCategory.label;

        let attrTitle = document.createAttribute('title');
        attrTitle.value = elementCategory.label;
        optionCategory.setAttributeNode(attrTitle);

        selectCategoryOption.appendChild(optionCategory);
      });

      categoryLabel.innerHTML = `Pre-Built Layouts`;
      categoryLabel.style = `text-align: right;`;

      this.handleCategoryChange(preBuiltSectionSelectList, galleryDiv);

      selectCategoryOption.onchange = () =>
        this.handleCategoryChange(preBuiltSectionSelectList, galleryDiv);

      let childComponents = [
        categoryLabel,
        selectCategoryOptionDiv,
        galleryDiv,
        codeViewer.getElement(),
      ];
      this.appendChildComponentsToContent(content, childComponents);

      selectCategoryOptionDiv.appendChild(selectCategoryOption);
      selectCategoryOptionDiv.style = `display:inline-block;float-right;`;
      selectCategoryOptionArrow.innerHTML = selectArrow;
      selectCategoryOptionDiv.appendChild(selectCategoryOptionArrow);

      appendToContent(selectCategoryOption, this.getPostContent());
      appendToContent(selectCategoryOptionDiv, this.getPostContent());
      appendToContent(categoryLabel, this.getPostContent());
      appendToContent(galleryDiv, this.getPostContent());
      appendToContent(content, this.getPostContent());

      codeViewer.refresh();
      setTimeout(() => codeViewer.focus(), 0);
      return content;
    },

    appendChildComponentsToContent(content, childrens) {
      childrens.forEach((child) => {
        if (child.id === '' || child.id === undefined) {
          child.style = `display: none; visibility: hidden; height: 0vh;`;
          content.appendChild(child);
        } else {
          content.appendChild(child);

          if (!child.className.includes('no-break')) {
            content.appendChild(this.getBreakPoint());
          }
          if (child.className.includes('two-break')) {
            content.appendChild(this.getBreakPoint());
          }
        }
      });
    },

    getContentActions() {
      const { editor } = this;
      const btn = document.createElement('button');
      const pfx = editor.getConfig('stylePrefix');

      btn.innerHTML = labels.buttonLabel;
      btn.className = `${pfx}btn-prim ${pfx}btn-import__pre-built-section btn btn-theme-submit btn-sm`;
      btn.title = titles.buttonTitle;
      btn.style = `float: right;`;
      btn.onclick = () => this.handleSave();
      return btn;
    },

    handleSave() {
      const { editor, target } = this;
      const code = this.getCodeViewer().getContent();
      target.set(keyMarketPlaceCustomCode, code);
      editor.Modal.close();
    },

    async handleCategoryChange(preBuiltSectionSelectList, galleryDiv) {
      const { editor, options } = this;
      const pfx = editor.getConfig('stylePrefix');
      const categorySelect = document.querySelector(
        `select[id=${pfx}pre-built-section-category-select]`,
      );
      const categoryValue = categorySelect ? categorySelect.value : 'ALL';
      if (categoryValue) {
        const { data: preBuiltSectionResponse } = await getPreBuiltSections(
          projectId,
          categoryValue,
        );
        preBuiltSectionSelectList = [];
        if (preBuiltSectionResponse) {
          preBuiltSectionResponse.map((preBuiltSectionBlock) => {
            let preBuiltSectionSelectObj = {};
            preBuiltSectionSelectObj['id'] = preBuiltSectionBlock.name;
            preBuiltSectionSelectObj['block'] = preBuiltSectionBlock;
            preBuiltSectionSelectList.push(preBuiltSectionSelectObj);
          });
        }

        galleryDiv.innerHTML = '';
        preBuiltSectionSelectList.forEach((element) => {
          let attrTitle = document.createAttribute('title');
          attrTitle.value = `Click to select ${element.block.label}`;

          let componentImage = document.createElement('div');
          componentImage.id = `${pfx}pre-built-section-gallery-img-${element.id}`;
          componentImage.className = `${pfx}pre-built-section-gallery-img`;
          componentImage.setAttributeNode(attrTitle);
          componentImage.innerHTML = `
        
        <div class="preview-pre-built-sections">
          <span class="inner-html">
            <img src="${
              process.env.REACT_APP_S3_URL + element.block.image
            }" loading="lazy" class="mkp-components" width="200" height="150">
          </span>
          <!-- <span class="label text-center">${element.block.label}</span> -->
        </div>

        `;
          componentImage.onclick = () =>
            this.handleClick(element, preBuiltSectionSelectList, galleryDiv);
          galleryDiv.appendChild(componentImage);
          galleryDiv.style = `display: flex; visibility:visible;`;
        });
      } else {
        galleryDiv.innerHTML = '';
        galleryDiv.style = `display:flex; visibility:hidden;`;
      }
    },

    async handleClick(selectedPrebuiltSection, preBuiltSectionSelectList, galleryDiv) {
      const { editor, options } = this;
      const pfx = editor.getConfig('stylePrefix');
      const imgComponents = document.querySelectorAll(`div.${pfx}pre-built-section-gallery-img`);
      const selectedImgComponent = document.querySelector(
        `div[id=${pfx}pre-built-section-gallery-img-${selectedPrebuiltSection.id}]`,
      );
      const selectCompContainer = selectedImgComponent.querySelector(`.inner-html`);

      imgComponents.forEach((imgComp) => {
        let imgCompLabelBtn = imgComp.querySelector(`.inner-html`);
        imgCompLabelBtn.classList.remove('selected-prebuilt-comp');
      });
      selectCompContainer.classList.add('selected-prebuilt-comp');

      if (selectedImgComponent) {
        // let mixedContent =
        //   selectedPrebuiltSection.block.contentStyle +
        //   selectedPrebuiltSection.block.contentHtml +
        //   selectedPrebuiltSection.block.contentJs;
        let mixedContent =
          selectedPrebuiltSection.block.contentStyle + selectedPrebuiltSection.block.contentHtml;
        this.getCodeViewer().setContent(mixedContent);
      } else {
        this.getCodeViewer().setContent(placeholderContent);
      }
      this.handleSave();
    },

    getCodeViewer() {
      const { editor } = this;

      if (!this.codeViewer) {
        this.codeViewer = editor.CodeManager.createViewer({
          codeName: 'htmlmixed',
          theme: 'hopscotch',
          readOnly: 0,
          ...codeViewOptions,
        });
      }

      return this.codeViewer;
    },

    ...commandPreBuiltSectionCode,
  });
};
